import { Box, Button, Typography, } from '@mui/material';
import React from 'react';
import styled from '@emotion/styled';


const TitleHeading = styled(Typography)`
font-size: 75px;
 line-height: 1;
 margin-bottom: 1rem;
 /* max-width: 1000px; */
 font-family: "SemiBold" !important;

@media(max-width: 800px){
        font-size: 60px;
    }
    @media(max-width: 599px){
        font-size: 40px;
    }
`


const Heading = (props) => {
  return ( 
  <TitleHeading  {...props} > {props.children} </TitleHeading>
  );
}
 
export default Heading;